import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useCallback,
} from "react";
import Modaleditcustomer from "./modaleditcustomer";
// import { datausers } from "../queue/datalist";
import { getcustomer } from "../../services/wms";
import Input from "./../wms/input";
import BranchContext from "./../context/branch";
import ScrollToTop from "../common/ScrollToTop";
// import DatePicker from "./datepicker";
import DatePicker from "react-datepicker";

const Editcustomer = () => {
  const { currentBranch } = useContext(BranchContext);
  const [isOpen, setisOpen] = useState(false);
  const [datausers, setdatausers] = useState([]);
  const [editdata, setEditdata] = useState([]);
  const [name, setname] = useState("");
  const [search, setsearch] = useState("");
  const [list, setList] = useState([]);
  const [register, setregister] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleOnchang = (event) => {
    setname(event.target.value);
  };

  useEffect(() => {
    const loadData = async () => {
      const { data: result } = await getcustomer(currentBranch._id, search);
      if (result.status === "success") {
        setdatausers(result.data.list);
      }
    };
    loadData();
  }, [search, currentBranch._id]);

  const observer = useRef();
  const lastBookElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        //  console.log(entries[0].isIntersecting,hasMore);

        if (entries[0].isIntersecting && hasMore) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  const handleCancle = () => {
    setEditdata([]);
    setisOpen(false);
  };
  const handleonClickclose = (event) => {
    setList(false);
  };
  const handleOnclick = () => {
    setsearch(name);
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      setsearch(name);
      //setPageNumber(1);
    }
  };
  const handleonClikisopen = (id) => {
    setEditdata({});
    const subdata = [...datausers];
    const index = datausers.findIndex((x) => x._id === id);
    setEditdata([datausers[index]]);
    setisOpen(true);
  };

  const handleChangStartDate = (event) => {
    setStartDate(event);
    setPageNumber(1);
  };
  const handleChangEndDate = (event) => {
    setEndDate(event);
    setPageNumber(1);
  };

  return (
    <div className="container-fluid">
      <Modaleditcustomer
        onCancel={handleCancle}
        // onClick={handleonClick}
        list={editdata}
        isOpen={isOpen}
      />
      <div className="row  ">
        <div className="col-lg-3 col-md-4 col-sm-6">
          <Input
            label="ค้นหาชื่อลูกค้า"
            name="weightno"
            placeholder="ชื่อลูกค้า/รหัสลูกค้า"
            onChange={handleOnchang}
            value={name}
            search="ค้นหา"
            onClick={handleOnclick}
            onKeyPress={handleKeyPress}
            lastBookElementRef={lastBookElementRef}
          />
        </div>

        <div className="col-lg-6 col-md-4 col-sm-6 text-end">
          <div className="mt-4">
            <span className="badge rounded bg-primary fs-4 m-2 ">
              <i className="bi bi-gear me-2"></i>
              เปลี่ยนลูกค้า
            </span>
          </div>
        </div>
      </div>
      <p className="text-success mt-2">
        แสดงข้อมูล {register ? register.length : 0} รายการ บนระบบ
      </p>

      {<ScrollToTop />}
      {datausers &&
        datausers.length > 0 &&
        datausers.map((item, index) => {
          if (datausers.length === index + 1) {
            return (
              <div className="card1 shadow  mt-2 " key={index}>
                <div className="row m-1">
                  <div className="col-xs-6 col-sm-4 col-md-2 lg-1 ">
                    <span className="badge rounded-pill bg-primary  mb-2 ">
                      {item.no}
                    </span>

                    <div
                      className="text-primary"
                      style={{ fontSize: 16, fontWeight: "bold" }}
                    >
                      {item.name}
                    </div>
                  </div>

                  <div className="col-xs-6 col-sm-4 col-md-2 lg-1">
                    <div>
                      <span className="text-dark">
                        รหัสลูกค้า :
                        <small style={{ fontSize: 14 }}> {item.code}</small>{" "}
                      </span>
                    </div>
                    <div>
                      <span className="text-dark">
                        {" "}
                        รหัสบัตร :
                        <small style={{ fontSize: 14 }}>
                          {" "}
                          {item.identityid}
                        </small>
                      </span>
                    </div>

                    <div />
                  </div>
                  <div className="col-xs-6 col-sm-4 col-md-2 lg-1">
                    <div>
                      <span className="text-dark">
                        {" "}
                        ประเภท :
                        <small style={{ fontSize: 14 }}> {item.typename}</small>
                      </span>
                    </div>
                    <div>
                      <span className="text-dark">
                        {" "}
                        เลขที่ :
                        <small style={{ fontSize: 14 }}> {item.address}</small>
                        &nbsp; หมู่ :
                        <small style={{ fontSize: 14 }}> {item.moo}</small>
                      </span>
                    </div>
                  </div>
                  <div className="col-xs-6 col-sm-4 col-md-2 lg-1">
                    <div>
                      <span className="text-dark">
                        {" "}
                        ตำบล :
                        <small style={{ fontSize: 14 }}> {item.tumbon}</small>
                      </span>
                    </div>
                    <div>
                      <div>
                        <span className="text-dark">
                          {" "}
                          อำเภอ :
                          <small style={{ fontSize: 14 }}> {item.amphur}</small>
                        </span>
                      </div>
                    </div>
                    <div>
                      <div></div>
                    </div>
                  </div>
                  <div className="col-xs-6 col-sm-4 col-md-2 lg-3">
                    <div>
                      <span className="text-dark">
                        {" "}
                        จังหวัด :
                        <small style={{ fontSize: 14 }}>
                          {" "}
                          {item.provincename}
                        </small>
                      </span>
                    </div>
                    <div>
                      <span className="text-dark">
                        {" "}
                        รหัสไปรษณีย์ :
                        <small style={{ fontSize: 14 }}> {item.postcode}</small>
                      </span>
                    </div>
                  </div>
                  <div className="col-lg-2  d-flex align-items-center d-flex justify-content-end">
                    {/* <i
                      onClick={() => handleonClikisopen()}
                      className="bi bi-trash me-4 text-danger"
                      style={{ fontSize: "29px", cursor: "pointer" }}
                    ></i> */}
                    <i
                      onClick={() => handleonClikisopen(item._id)}
                      className="bi bi-pencil-square me-2 text-info"
                      style={{ fontSize: "29px", cursor: "pointer" }}
                    ></i>
                  </div>
                </div>
              </div>
            );
          } else {
            return (
              <div className="card1 shadow  mt-2 " key={index}>
                <div className="row m-1">
                  <div className="col-xs-6 col-sm-4 col-md-2  ">
                    <span className="badge rounded-pill bg-primary me-2 ">
                      {index + 1}
                    </span>

                    <span className="text-primary fw-bold">{item.name}</span>
                  </div>

                  <div className="col-xs-6 col-sm-4 col-md-2 lg-1">
                    <div>
                      <span className="text-dark">
                        รหัสลูกค้า :
                        <small style={{ fontSize: 14 }}> {item.code}</small>{" "}
                      </span>
                    </div>
                    <div>
                      <span className="text-dark">
                        {" "}
                        รหัสบัตร :
                        <small style={{ fontSize: 14 }}>
                          {" "}
                          {item.identityid}
                        </small>
                      </span>
                    </div>

                    <div />
                  </div>
                  <div className="col-xs-6 col-sm-4 col-md-2 lg-1">
                    <div>
                      <span className="text-dark">
                        {" "}
                        ประเภท :
                        <small style={{ fontSize: 14 }}> {item.typename}</small>
                      </span>
                    </div>
                    <div>
                      <span className="text-dark">
                        {" "}
                        เลขที่ :
                        <small style={{ fontSize: 14 }}> {item.address}</small>
                        &nbsp; หมู่ :
                        <small style={{ fontSize: 14 }}> {item.moo}</small>
                      </span>
                    </div>
                  </div>
                  <div className="col-xs-6 col-sm-4 col-md-2 lg-1">
                    <div>
                      <span className="text-dark">
                        {" "}
                        ตำบล :
                        <small style={{ fontSize: 14 }}> {item.tumbon}</small>
                      </span>
                    </div>
                    <div>
                      <div>
                        <span className="text-dark">
                          {" "}
                          อำเภอ :
                          <small style={{ fontSize: 14 }}> {item.amphur}</small>
                        </span>
                      </div>
                    </div>
                    <div>
                      <div></div>
                    </div>
                  </div>
                  <div className="col-xs-6 col-sm-4 col-md-2 lg-3">
                    <div>
                      <span className="text-dark">
                        {" "}
                        จังหวัด :
                        <small style={{ fontSize: 14 }}>
                          {" "}
                          {item.provincename}
                        </small>
                      </span>
                    </div>
                    <div>
                      <span className="text-dark">
                        {" "}
                        รหัสไปรษณีย์ :
                        <small style={{ fontSize: 14 }}> {item.postcode}</small>
                      </span>
                    </div>
                  </div>
                  <div className="col-lg-2  d-flex align-items-center d-flex justify-content-end">
                    {/* <i
                      onClick={() => handleonClikisopen()}
                      className="bi bi-trash me-4 text-danger"
                      style={{ fontSize: "29px", cursor: "pointer" }}
                    ></i> */}
                    <i
                      onClick={() => handleonClikisopen(item._id)}
                      className="bi bi-pencil-square me-2 text-info"
                      style={{ fontSize: "29px", cursor: "pointer" }}
                    ></i>
                  </div>
                </div>
              </div>
            );
          }
        })}
    </div>
  );
};

export default Editcustomer;
